import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(html: string | undefined): SafeHtml {
    if (!html) return '';

    const cleanHtml = DOMPurify.sanitize(html);

    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
  }
}
